module.exports = __webpack_public_path__ + "static/media/upi_message_success.c466ec8b.svg";